/**
 * WavyMark — small wavy-line accent in terra. House glyph used in
 * eyebrow rows and section headers across the workshop pages.
 *
 * `size` is the rendered height in px; width scales 1.75x to keep the
 * wave's proportions. Color defaults to the terra token but can be
 * overridden (e.g. cream on dark panels).
 */
export function WavyMark({
  size = 16,
  color = "var(--terra)",
  className = "",
}: {
  size?: number;
  color?: string;
  className?: string;
}) {
  return (
    <svg
      width={size * 1.75}
      height={size}
      viewBox="0 0 28 16"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M1.5 8.5 C 3.5 3.2, 6.8 3.8, 9.2 7.6 C 11.4 11.1, 13.8 12.4, 16.2 8.6 C 18.4 5.2, 21.5 4.2, 24 6.8 C 25 7.8, 26 7.4, 26.5 6.9"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
